<template>
  <v-app-bar class="noPrint" dense dark fixed clipped-left color="#2c2e3e" app>
    <v-toolbar-title>
      <v-img src="@/assets/inncash-logo-white.webp" width="104"></v-img>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <night-switch />

    <notification v-if="hasNotificationsEnabled"/>

    <module-selector v-if="availableModules.length > 1"></module-selector>

    <user-profile-menu />
  </v-app-bar>
</template>

<script>
import { mapState } from 'vuex';
import UserProfileMenu from '@/components/userProfile/UserProfileMenu.vue';
import NightSwitch from '@/components/night_switch/NightSwitch.vue';
import ModuleSelector from '@/components/modules/ModuleSelector.vue';
import Notification from '@/components/navigation/toolbar/components/Notification.vue';

export default {
  name: 'Toolbar',
  components: {
    UserProfileMenu,
    NightSwitch,
    ModuleSelector,
    Notification,
  },
  data: () => ({
    buttons: {},
    user: {},
    avatar: null,
  }),
  computed: {
    ...mapState('authentication', ['availableModules']),
    hasNotificationsEnabled() {
      return Boolean(Number(this.$session.get('user_access-notifications')));
    },
  },
};
</script>
